<template>
	<article class="closed-list--page">
		<p class="closed-list__desc">
			* 이름, 전화번호, 이메일 정보는 탈퇴 6개월 이내 회원만 조회
			가능합니다.<br />* 6개월 이후 탈퇴회원 개인정보는 DB에서 완전
			파기됩니다.
		</p>
		<ListFilter />
		<ListContainer>
			<table class="table-main">
				<thead>
					<tr>
						<th>#</th>
						<th>회원번호</th>
						<th>닉네임</th>
						<th>가입일시</th>
						<th>탈퇴일시</th>
						<th>데이터파기(예정)일</th>
						<th>리뷰수</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in getClosedList" :key="item.idRegister">
						<td>{{ item.idx }}</td>
						<td>{{ item.idRegister }}</td>
						<td>
							<a class="closed-list__link" :href="item.infoLink">
								{{ item.nickname }}
							</a>
						</td>
						<td>{{ item.createDate }}</td>
						<td>{{ item.closedDate }}</td>
						<td>{{ item.after6mDate }}</td>
						<td>{{ item.reviewCount }}</td>
					</tr>
				</tbody>
			</table>
		</ListContainer>
	</article>
</template>

<script>
	import { mapGetters } from 'vuex';
	import ListFilter from '@/components/register/ListFilter.vue';
	import ListContainer from '@/components/register/ListContainer.vue';

	export default {
		name: 'ClosedList',
		components: { ListFilter, ListContainer },
		computed: {
			...mapGetters('register', ['getClosedList']),
		},
		beforeCreate() {
			this.$store.commit('register/changeState', [
				{
					key: 'keyList',
					value: [
						'idRegister',
						'email',
						'userName',
						'nickname',
						'userTel',
						'closedDateRange',
					],
				},
				{
					key: 'orderList',
					value: [
						{ id: 11, text: '최근탈퇴순' },
						{ id: 12, text: '이전탈퇴순' },
						{ id: 3, text: '회원번호내림차순' },
						{ id: 4, text: '회원번호오름차순' },
						{ id: 7, text: '리뷰많은순' },
						{ id: 8, text: '리뷰적은순' },
					],
				},
				{ key: 'pageType', value: 'closed' },
				{ key: 'order', value: 11 },
				{ key: 'orderDefault', value: 11 },
				{ key: 'limit', value: 10 },
			]);
		},
	};
</script>

<style lang="scss" scoped>
	.closed-list--page {
		.closed-list__desc {
			margin-top: 24px;
			line-height: 18px;
			color: $red;
			font-size: 1rem;
			font-weight: 700;
		}

		.closed-list__link {
			color: $btn-blue;
			font-weight: 700;

			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
